/**
 * Step copy + ordering for the /ancillaries wizard. Keys map to the
 * canonical AdditionalService type strings the providers emit (`bag`,
 * `seat`, `sportsEquipment`, `service`, `meal`, `loungeAccess`,
 * `disabilityAssistance`); each value carries the step's `order`,
 * display name, title, and body copy.
 *
 * `order` is the single source of truth for step sequence — the wizard
 * sorts by it rather than trusting the incidental envelope key order
 * (which follows KYTE_ANCILLARY_CAPABILITIES / Object.keys insertion).
 * Contract: `bag` is always the first step and `seat` (the seatmap) is
 * always the last; the picks in between sit in the middle. `seat` sits
 * at 99 so new middle steps can be inserted without renumbering it.
 *
 * The wizard reads this map in two places: `steps()` builds the
 * navigation by looking each present envelope key up here and sorting
 * by `order`; the active-step component pulls `title` and `description`
 * straight off the entry. Selection compatibility within a step is
 * driven by `combineWith` / `incompatibleWith` on each catalog entry —
 * every step is multi-selectable by default.
 */
export const STEPS_INFO = {
  bag: {
    order: 1,
    name: 'Bagagli da stiva',
    title: 'Vuoi aggiungere un bagaglio da stiva?',
    description:
      'Puoi aggiungere bagagli da stiva separatamente per ogni passeggero e per ogni tratta.',
  },
  sportsEquipment: {
    order: 2,
    name: 'Attrezzatura sportiva',
    title: "Vuoi aggiungere un'attrezzatura sportiva?",
    description:
      'Puoi aggiungere attrezzature sportive separatamente per ogni passeggero e per ogni tratta. Le condizioni e i limiti di peso possono variare in base alla compagnia aerea.',
  },
  service: {
    order: 3,
    name: 'Servizi extra',
    title: 'Vuoi aggiungere servizi extra?',
    description:
      'Puoi aggiungere servizi extra separatamente per ogni passeggero e per ogni tratta. La disponibilità dei servizi può variare in base alla compagnia aerea.',
  },
  meal: {
    order: 4,
    name: 'Pasti',
    title: 'Vuoi aggiungere un pasto a bordo?',
    description:
      'Puoi scegliere un pasto separatamente per ogni passeggero e per ogni tratta.',
  },
  loungeAccess: {
    order: 5,
    name: 'Accesso lounge',
    title: "Vuoi aggiungere l'accesso alla lounge?",
    description:
      'Accesso alle lounge aeroportuali disponibili per questa tratta.',
  },
  disabilityAssistance: {
    order: 6,
    name: 'Assistenza disabilità',
    title: 'Hai bisogno di assistenza speciale?',
    description:
      'Puoi richiedere assistenza speciale per ogni passeggero che ne ha bisogno.',
  },
  // seatmap always last — see contract above.
  seat: { order: 99, name: 'Posti', title: '', description: '' },
};
